import ButtonLink from '@/components/links/ButtonLink';
import useLocale from 'next-translate/useTranslation';
import Image from 'next/image';

export default function Certifications() {
  const { t } = useLocale('b2b');

  return (
    <div className='bg-white py-24 dark:bg-slate-900 sm:py-32'>
      <div className='mx-auto max-w-7xl px-6 lg:px-8'>
        <div className='grid grid-cols-1 items-center gap-x-8 gap-y-8 lg:grid-cols-2'>
          <div className='mx-auto w-full max-w-xl lg:mx-0'>
            <h2 className='text-3xl font-bold tracking-tight text-gray-900 dark:text-white'>
              {t('Easy-Peasy.AI Chatbot')}
            </h2>
            <h2 className='mt-6 text-xl font-bold tracking-tight text-gray-900 dark:text-white'>
              {t('For WordPress')}
            </h2>
            <p className='mt-6 text-lg leading-8 text-gray-600 dark:text-gray-300'>
              {t('Improve your website by integrating Easy-Peasy.AI Chatbot. Create a personalized AI chatbot, embed it seamlessly into your site, and enhance customer support, lead generation, and user engagement. This plugin allows you to easily connect your Easy-Peasy.AI chatbot to your WordPress website.')}
            </p>
            <div className='mt-10 flex items-center gap-x-6'>
              <ButtonLink
                href='/Easy-Peasy-AI-Bot-Wordpress.zip'
                variant='dark'
                target='_blank'
              >
                {t('Download Now')}
              </ButtonLink>
            </div>
          </div>
          <div className='mx-auto grid items-center '>
            <Image
              className='min-h-24 w-auto'
              src='/images/about-us/easy-peasy-logo-long copy.png'
              alt='Easy-Peasy.AI logo'
              width={200}
              height={200}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
